import { RouterProvider } from '@tanstack/react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Provider } from 'react-redux';
import { FeatureFlagsProvider } from '~/contexts';
import { queryClient } from '~/queries';
import { setupStore } from './state/store.ts';
import '@janeapp/burrito-design-system/fonts.css';
import '@janeapp/burrito-design-system/globalTheme';
import './index.css';
import { ViewProvider } from './hooks/index.ts';
import { APIProvider } from '@vis.gl/react-google-maps';
import { env } from '~/env';
import { router } from '~/router';

const mapsApiKey = env.VITE_GOOGLE_API_KEY;

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <FeatureFlagsProvider>
        <Provider store={setupStore()}>
          <ViewProvider>
            <APIProvider apiKey={mapsApiKey}>
              <RouterProvider router={router} />
            </APIProvider>
          </ViewProvider>
        </Provider>
      </FeatureFlagsProvider>
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="top-right" />
    </QueryClientProvider>
  );
}
